import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, intlShape} from 'react-intl';
import classnames from 'classnames';
import OnBlurTextInput from 'components/forms/BasicFormFields/OnBlurTextInput';
import AutoSaveField from './abstract/AutoSaveField.jsx';
import {EmptyFunc, isFunction, isNoU} from "utils/DBUtils";

class AutoSaveTextInput extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    linkedValue: PropTypes.any,
  };

  static defaultProps = {
    onValidationError: EmptyFunc,
    onValidationSuccess: EmptyFunc
  };

  constructor(props) {
    super(props);
    const value = this.props.defaultValue || '';
    this.state = {
      value,
      isValid: true,
      textLength: value.length
    };
  }

  getValueFromOnChange = (event, data) => {
    const value = event.target.value || '';
    this.setState({
      value,
      isValid: true,
      textLength: value.length
    });
    return value;
  };

  onValidationError = (name, failedRules) => {
    this.props.onValidationError(name, failedRules);
    if (this.state.isValid) {
      this.setState({isValid: false});
    }
  };

  onValidationSuccess = name => {
    this.props.onValidationSuccess(name);
    this.setState({isValid: true});
  };

  commaListValue(value) {
    return isNoU(value) ? "" : value.join(',');
  }

  get hasValidDefaultValue() {
    // is valid value if not null or undefined AND either expecting an array OR expecting a string and that string value is not blank
    return !isNoU(this.props.defaultValue) && (this.props.asList || String(this.props.defaultValue).trim() !== "");
  }

  onValueChanged = (value, field, errors) => {
    let modValue = value;
    if (this.props.asList) {
      modValue = value.split(',').filter((item) => !isNoU(item) && item.trim() !== '');
    }

    this.props.onValueChanged(modValue, field, errors);
  };

  onTextLengthChange = textLength => {
    this.setState({textLength});
  };

  render() {
    let value = this.props.defaultValue;

    // Use linked value if we don't have a value to show
    if (!this.hasValidDefaultValue && !isNoU(this.props.linkedValue)) {
      value = this.props.linkedValue;
    }

    // convert current value if function is provided
    if (isFunction(this.props.valueProjection)) {
      value = this.props.valueProjection(value, this.props);
    }

    // make a comma separated string if is a list value
    if (this.props.asList) {
      value = this.commaListValue(value);
    }

    // check for a starter value
    if (isNoU(value) && !isNoU(this.props.starterValue)) {
      value = this.props.starterValue;
    }

    // value logic before above code (valueProjection support) for reference
    // let defaultValue = this.props.asList ? this.commaListValue() : this.hasValidDefaultValue ? this.props.defaultValue : this.props.linkedValue;

    // Need a more specific error class so we don't say .error .ui.form textarea since that will also highlight this if the accordion has .error

    const {label, ...noLabelProps} = this.props;

    return (
      <div className={classnames({error: !this.state.isValid})}>
        <AutoSaveField control={OnBlurTextInput}
                       usingLinkedValue={!isNoU(this.props.linkedValue) && !this.hasValidDefaultValue}
                       getValueFromOnChange={this.getValueFromOnChange}
                       placeholder={this.props && this.props.placeholderKey ? this.props.intl.formatMessage({id: this.props.placeholderKey}) : ""}
                       supportsLoading={true}
                       {...noLabelProps}
                       defaultValue={value}
                       onValidationError={this.onValidationError}
                       onValidationSuccess={this.onValidationSuccess}
                       onPersistValue={this.onValueChanged}
                       getTextLengthCallback={this.onTextLengthChange}
                       spellCheck={true} />
        {this.props.maxLength && (
          <div className='text-input-feedback'>
            {this.state.value ? this.state.textLength : (this.props.linkedValue ? this.props.linkedValue.length : 0)}/{this.props.maxLength}
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(AutoSaveTextInput);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveTextInput.jsx